(function () {
  var TYPE_MS = 65;
  var DELETE_MS = 35;
  var PAUSE_AFTER_TYPE_MS = 1700;
  var PAUSE_AFTER_DELETE_MS = 400;
  // A CSS rule elsewhere in the theme hides genuinely empty <p> tags
  // (p:empty { display: none }), which would collapse the bar's height for
  // the moment between deleting one message and typing the next. A
  // non-breaking space keeps the element non-empty without being visible.
  var EMPTY = ' ';

  function setStageText(textEl, value) {
    textEl.textContent = value === '' ? EMPTY : value;
  }

  function initTypewriter(stageSlide) {
    var textEl = stageSlide.querySelector('.announcement-bar__text');
    if (!textEl) return;

    var allSlides = Array.prototype.slice.call(
      stageSlide.parentElement.querySelectorAll('.announcement-bar__slide')
    );
    var messages = allSlides
      .map(function (slide) {
        var t = slide.querySelector('.announcement-bar__text');
        return t ? t.textContent.trim() : '';
      })
      .filter(Boolean);

    if (!messages.length) return;

    // Collapse every message onto one stage slide; the typewriter cycles
    // through all of them there instead of Horizon's own cross-fade slider.
    allSlides.forEach(function (slide) {
      if (slide !== stageSlide) slide.remove();
    });
    stageSlide.setAttribute('aria-hidden', 'false');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      textEl.textContent = messages[0];
      return;
    }

    setStageText(textEl, '');
    var msgIndex = 0;

    function typeMessage() {
      var message = messages[msgIndex];
      var charIndex = 0;

      (function typeChar() {
        setStageText(textEl, message.slice(0, charIndex));
        charIndex += 1;
        if (charIndex <= message.length) {
          setTimeout(typeChar, TYPE_MS);
        } else {
          setTimeout(deleteMessage, PAUSE_AFTER_TYPE_MS);
        }
      })();
    }

    function deleteMessage() {
      var message = messages[msgIndex];
      var charIndex = message.length;

      (function deleteChar() {
        setStageText(textEl, message.slice(0, charIndex));
        charIndex -= 1;
        if (charIndex >= 0) {
          setTimeout(deleteChar, DELETE_MS);
        } else {
          msgIndex = (msgIndex + 1) % messages.length;
          setTimeout(typeMessage, PAUSE_AFTER_DELETE_MS);
        }
      })();
    }

    typeMessage();
  }

  function setup() {
    // When more than one announcement block exists, Horizon's own
    // announcement-bar.js runs a cross-fade slider (autoplay attribute set
    // on the component). Leave that alone rather than fight it; the
    // typewriter only takes over the single-message case.
    var slider = document.querySelector('.announcement-bar__slider');
    if (slider && slider.hasAttribute('autoplay')) return;

    var firstSlide = document.querySelector('.announcement-bar__slide');
    if (firstSlide) initTypewriter(firstSlide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
